"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmsVideo = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var ParamExtractor_1 = require("@wix/dealer-common/dist/src/services/ParamExtractor");
var Catch_1 = require("../../Catch");
var WIDTH_PROPERTY = 'width';
var HEIGHT_PROPERTY = 'height';
var YOUTUBE_ID_PROPERTY = 'youtubeId';
var CONTROLS_PROPERTY = 'controls';
var AUTOPLAY_PROPERTY = 'autoplay';
var SHOW_FS_PROPERTY = 'showFs';
var SHOW_INFO_PROPERTY = 'showInfo';
var YOUTUBE_BASE_URL = 'https://www.youtube.com/embed/';
var CmsVideo = /** @class */ (function (_super) {
    tslib_1.__extends(CmsVideo, _super);
    function CmsVideo(props) {
        var _this = _super.call(this, props) || this;
        _this.paramExtractorWithElement = ParamExtractor_1.extractParam.bind(ParamExtractor_1.extractParam, _this.props.element, _this.props.context);
        return _this;
    }
    CmsVideo.prototype.getVideoSrc = function () {
        return ("" + YOUTUBE_BASE_URL + this.paramExtractorWithElement(YOUTUBE_ID_PROPERTY) + "?controls=" +
            ((this.paramExtractorWithElement(CONTROLS_PROPERTY) ? '2' : '0') + "&modestbranding=1") +
            ("" + (this.paramExtractorWithElement(AUTOPLAY_PROPERTY) ? '&autoplay=1' : '')) +
            ("" + (this.paramExtractorWithElement(SHOW_FS_PROPERTY) ? '' : '&fs=0')) +
            ("" + (this.paramExtractorWithElement(SHOW_INFO_PROPERTY) ? '' : '&showinfo=0')));
    };
    CmsVideo.prototype.getHeight = function () {
        return this.paramExtractorWithElement(HEIGHT_PROPERTY);
    };
    CmsVideo.prototype.getWidth = function () {
        return this.paramExtractorWithElement(WIDTH_PROPERTY);
    };
    CmsVideo.prototype.render = function () {
        var _this = this;
        return Catch_1.Catch({
            onError: this.props.onError,
            render: function () { return (React.createElement("iframe", { src: _this.getVideoSrc(), height: _this.getHeight(), width: _this.getWidth(), allowFullScreen: true, frameBorder: "0" })); },
        });
    };
    return CmsVideo;
}(React.Component));
exports.CmsVideo = CmsVideo;
//# sourceMappingURL=CmsVideo.js.map